<template>
  <div class="form__input">
    <div class="form__input__wrap">
      <label v-word="labelWord" />
      <select class="language-select" v-model="language">
        <option v-for="languageItem in loadedLanguages" :value="languageItem.Guid">{{ languageItem.Name }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import wordings from '../utils/wordings';
import wordDirective from '../directives/word';
import formElement from '../mixins/form-element';

export default {
  mixins: [formElement],
  directives: {
    word: wordDirective,
  },
  props: [
    'label',
    'labelWord',
    'wordingsEditable',
    'wordings',
    'data',
    'wordingsMeta',
    'loadedLanguages',
    'data'
  ],
  computed: {
    language: {
      get() {
        return this.data.val || '';
      },
      set(newVal) {
        this.$emit('change', newVal, this.data.valName);
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/LanguageSelect.vue